import React, { useEffect, useState, useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, MenuItem, FormControl, Select, Button, TextField, Checkbox, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import axios from 'axios'
import Pagination from "react-js-pagination";
import { useNavigate } from 'react-router-dom';
import { TbLoader } from 'react-icons/tb';
import ItemConfigList from '../../../components/ItemConfigList';
import { MdOutlineRefresh } from "react-icons/md";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux';
import { setCheckedUseItm, setItemPageInit, setKeywordItm, setOrderUseItm, setPageItm, setParamItm, setPicSearItm, setSearchItm, setSearchPicItm, setSearchType1Itm, setSearchType2Itm } from '../../../redux/itemPageSlice';

const useStyles = makeStyles((theme)=>({
  box:{
    margin:'0 auto',
    maxWidth:'1800px',
    padding:'0 20px 20px 20px',
  },
  h1SearchDiv:{
    padding:'40px 0px 0 0',
    display:'flex',
    flexDirection:'column',
  },
  itemConfigBlockH1:{
    fontWeight:'700',
    fontSize:'22px',
    display: 'flex'
  },
  datagridBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  head: {
    borderTop: '1px solid #D3D3D3',
    borderBottom: '1px solid #D3D3D3',
    display: 'flex',

    [theme.breakpoints.down(1025)]: {
      display:'none'
    } 
  },
  mobilehead:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      display:'block',
      borderTop: '1px solid #D3D3D3',
      borderBottom: '1px solid #D3D3D3',
      display: 'flex',
    }  
  },
  checkBox: {
    borderRight: '1px solid #D3D3D3',
    width: '5%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  oneBox: {
    borderRight: '1px solid #D3D3D3',
    width: '8%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    wordBreak:'break-all',

    [theme.breakpoints.down(1025)]: {
      width: '15%',
    } 
  },
  twoBox: {
    borderLeft: '1px solid #D3D3D3',
    borderRight: '1px solid #D3D3D3',
    display: 'flex',
    flexDirection: 'column',
    width: '10%',
    wordBreak:'break-all',

    [theme.breakpoints.down(1025)]: {
      width: '31%',
    } 
  },
  twoBox2: {
    borderRight: '1px solid #D3D3D3',
    display: 'flex',
    flexDirection: 'column',
    width: '10%',
    wordBreak:'break-all',

    [theme.breakpoints.down(1025)]: {
      width: '31%',
    } 
  },
  twoBox3: {
    borderLeft: '1px solid #D3D3D3',
    borderRight: '1px solid #D3D3D3',
    display: 'flex',
    flexDirection: 'column',
    width: '10%',
    wordBreak:'break-all',

    [theme.breakpoints.down(1025)]: {
      width: '50%',
    } 
  },
  imgBox: {
    borderRight: '1px solid #D3D3D3',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '15%',
    wordBreak:'break-all',
  },
  threeBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '8%',
    wordBreak:'break-all',
  },
  inBox1: {
    borderRight: '1px solid #D3D3D3',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:last-child':{
      borderRight: 'none',
    },
  },
  inBox2: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: '1px solid #D3D3D3',
  },
  inBox3: {
    paddingTop:'12px'
  },
  threeInBox1: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:last-child':{
      borderRight: 'none',
    },
  },
  threeInBox2: {
    borderBottom:'1px solid #D3D3D3',
    borderTop:'1px solid #D3D3D3',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:last-child':{
      borderRight: 'none',
    },
  },
  threeInBox3: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flexOutBox:{
    flex: 1,
    display: 'flex',
    // justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  flexBox:{
    display: 'flex',
    width: '100%',
    wordBreak:'break-all',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom:'1px solid #D3D3D3',

    [theme.breakpoints.down(1025)]: {
      width: '31%',
    } 
  },
  innerClass: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '15px',
    listStyle: 'none',
    padding: 0,
  },
  itemClass: {
    minWidth: '30px',
    border: '1px solid #e2e2e2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1rem',
  },
  itemClassFirst: {
      borderRadius: '15px 0 0 15px',
  },
  itemClassLast: {
      borderRadius: '0 15px 15px 0',
  },
  linkClass: {
      textDecoration: 'none',
      color: '#383A3F',
      fontSize: '1rem',
  },
  activeClass: {
      backgroundColor: '#383A3F'
  },
  activeLinkClass: {
      color: 'white',
  },
  btnDiv:{
    display:'flex',
    justifyContent:'end',
    margin:'30px 0'
  },
  btnDivTop:{
    display:'flex',
    margin:'0 0 0 40px',
    [theme.breakpoints.down(1025)]: {
      margin:'0',
    }
  },
  btnDivTopLeft:{

  },
  btnDivTopRight:{
    display:'flex',
    justifyContent:'end',
  },
  btnButton:{
    margin:'0 20px'
  },
  formDiv:{
    display:'flex',
    marginRight:'10px'
  },
  bottomDiv:{
    padding:'30px 0',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'flex-start',
    }
  },
  formDiv:{
    display:'flex',
    marginRight:'10px',
    [theme.breakpoints.down(1025)]: {
      margin:'10px 0  0 0',
    }
  },
  RightDiv:{
    padding:'10px 0',
    display:'flex',
    alignItems:'center',
  },
  flexDiv:{
    display:'flex',
    alignItems:'center',
    marginBottom:'10px',
    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'flex-start',
    }
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
  navibox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems:'center'
  },
  naviArrow: {
    marginTop: 13,
    cursor: 'pointer',
    border: '1px solid gray',
    padding: 5
  }

}));


const ItemConfig = ({setAdmin}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let navigate = useNavigate();
  const [checks, setChecks] = useState([])
  const [allChecked, setAllChecked] = useState(false)

  const [data, setData] = useState([])

  const [cateList, setCateList] = useState([])
  const [type1, setType1] = useState([])
  const [type2, setType2] = useState([])
  const [type3, setType3] = useState([])
  const [colorList, setColorList] = useState([])
  const [picList, setPicList] = useState([]) 

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [loading, setLoading] = useState(false)

  const [delDial, setDelDial] = useState(false)

  const [pasings, setPasings] = useState(0);
  
  const [allQty, setAllQty] = useState(0);

  const dispatch = useDispatch()
  const page = useSelector(state => state.itemPage.page);
  const param = useSelector(state => state.itemPage.param);
  const keyword = useSelector(state => state.itemPage.keyword);
  const search = useSelector(state => state.itemPage.search);
  const picSear = useSelector(state => state.itemPage.picSear);
  const searchPic = useSelector(state => state.itemPage.searchPic);
  const searchType1 = useSelector(state => state.itemPage.searchType1);
  const searchType2 = useSelector(state => state.itemPage.searchType2);
  const checkedUse = useSelector(state => state.itemPage.checkedUse);
  const orderUse = useSelector(state => state.itemPage.orderUse);


  // const [page, setPage] = useState(1);

  // const [param, setParam] = useState(false)

  // const [keyword, setKeyword] = useState('');
  // const [search, setSearch] = useState(false);
  // const [picSear, setPicSear] = useState(false);
  // const [searchPic, setSearchPic] = useState(1);

  // const [searchType1, setSearchType1] = useState(0);
  // const [searchType2, setSearchType2] = useState(0);

  // const [checkedUse, setCheckedUse] = useState(false)

  // const [orderUse, setOrderUse] = useState(0)

  useEffect(() => {
    window.scrollTo(0, 0);
    setAdmin(false)

    return () => {
      setData([])
    }
  }, [])

useEffect(() => {
  console.log()
}, [])


  const getItems = useCallback(async() => {
    
    try {
      setLoading(true)
      const res = await axios.post('/api/adm/itemConfigView/',  {page: page, order_use: orderUse})

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }
      setData([])
      setData(res.data.result)

      setPasings(res.data.itemCount)
      setColorList(res.data.colorList)

      setCateList(res.data.cateList)
      setPicList(res.data.picList)      

      setType1(res.data.cateList.filter(item => item['ca_id'].length === 2))
      setType2(res.data.cateList.filter(item => item['ca_id'].length === 4))
      setType3(res.data.cateList.filter(item => item['ca_id'].length === 6))

      setLoading(false)
      
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
  }, [page, orderUse])

  const searchItem = useCallback(async() => {
    // setPicSear(false)
    dispatch(setPicSearItm(false))
    // setSearch(true)
    dispatch(setSearchItm(true))

    try {
      setLoading(true)
      const res = await axios.post('/api/adm/itemSearch/', {page: page, search_type1: searchType1, search_type2: searchType2, keyword: keyword, order_use: orderUse} )

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }
      setData([])
      setData(res.data.result)
      setPasings(res.data.itemCount)
      setColorList(res.data.colorList)

      setCateList(res.data.cateList)
      setPicList(res.data.picList)

      setType1(res.data.cateList.filter(item => item['ca_id'].length === 2))
      setType2(res.data.cateList.filter(item => item['ca_id'].length === 4))
      setType3(res.data.cateList.filter(item => item['ca_id'].length === 6))

      setChecks([])
      setAllChecked(false)
      setLoading(false)
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }

    if (keyword === '' && searchType1 === 0){
      dispatch(setSearchItm(false))
    }

  }, [page, searchType1, searchType2, keyword, orderUse])

  const searchPicItem = useCallback(async() => {
    // setPicSear(true)
    dispatch(setPicSearItm(true))
    dispatch(setSearchItm(false))

    try {
      setLoading(true)
      const res = await axios.post('/api/adm/itemPicSearch/', {page: page, keyword: searchPic, order_use: orderUse} )

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return;
      }

      setData([])
      setData(res.data.result)
      setPasings(res.data.itemCount)
      setColorList(res.data.colorList)

      setCateList(res.data.cateList)
      setPicList(res.data.picList)

      setType1(res.data.cateList.filter(item => item['ca_id'].length === 2))
      setType2(res.data.cateList.filter(item => item['ca_id'].length === 4))
      setType3(res.data.cateList.filter(item => item['ca_id'].length === 6))

      setChecks([])
      setAllChecked(false)
      setLoading(false)
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }

  }, [page, searchPic, orderUse])


  const handlePageChange = (page) => {
    // setPage(page)
    dispatch(setPageItm(page))
  };

  useEffect(() => {

    if(search) {
      searchItem()
    } else if (picSear) {
      searchPicItem()
    } else{
      getItems()
    }
    setChecks([])
    setAllChecked(false)
  }, [page, orderUse, param])

  useEffect(() => {
    // 전체선택 관련 로직
    let allCheckList = []

    if(allChecked) {
      data.forEach(item => allCheckList.push(item['it_id']));
      setChecks(allCheckList)
    } else {
      setChecks(allCheckList)
    }
    
  }, [allChecked])

  useEffect(() => {
    // 사용여부 전체선택 관련 로직
    let dataArr = [...data]


    dataArr.forEach((itm, idx) => {
      dataArr[idx]['it_use'] = checkedUse ? 1 : 0
    })
    setData(dataArr)

    
  }, [checkedUse])


  const editSelItems = useCallback(async() => {
    let itList = []
    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem['it_id'] === arrItem){
          itList.push({
            it_id: dataItem['it_id'],
            ca_id: dataItem['ca_id'],
            ca_id2: dataItem['ca_id2'],
            ca_id3: dataItem['ca_id3'],
            it_name: dataItem['it_name'],
            it_price: dataItem['it_price'],
            it_stock_qty: dataItem['it_stock_qty'],
            it_use: dataItem['it_use'],
            it_soldout: dataItem['it_soldout'],
            pic_id: dataItem['pic_id'],
            color_id: dataItem['color_id'],
            it_maker: dataItem['it_maker'],
            it_type1: dataItem['it_type1'],
            it_type2: dataItem['it_type2'],
            it_type3: dataItem['it_type3'],
            it_type4: dataItem['it_type4'],
            it_type5: dataItem['it_type5']
          })
        } 
      })
    })

    try {
      const res = await axios.post('/api/adm/itemConfigSelectEdit/', {it_list: itList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }

      setSuccSnack(true)
      setChecks([])
      setAllChecked(false)
      // setParam(!param)
      dispatch(setParamItm(!param))
      
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }, [checks, data])

  const editAllQty = useCallback(async() => {
    let allCheckList = []
    data.forEach(item => allCheckList.push(item['it_id']));

    let itList = []
    allCheckList.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem['it_id'] === arrItem){
          itList.push({
            it_id: dataItem['it_id'],
            ca_id: dataItem['ca_id'],
            ca_id2: dataItem['ca_id2'],
            ca_id3: dataItem['ca_id3'],
            it_name: dataItem['it_name'],
            it_price: dataItem['it_price'],
            it_stock_qty: allQty,
            it_use: dataItem['it_use'],
            it_soldout: dataItem['it_soldout'],
            pic_id: dataItem['pic_id'],
            color_id: dataItem['color_id'],
            it_maker: dataItem['it_maker'],
            it_type1: dataItem['it_type1'],
            it_type2: dataItem['it_type2'],
            it_type3: dataItem['it_type3'],
            it_type4: dataItem['it_type4'],
            it_type5: dataItem['it_type5']
          })
        } 
      })
    })



    try {
      const res = await axios.post('/api/adm/itemConfigSelectEdit/', {it_list: itList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }

      setSuccSnack(true)
      setChecks([])
      setAllChecked(false)
      // setParam(!param)
      dispatch(setParamItm(!param))
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }, [data, allQty])

  const delSelItems = useCallback(async() => {
    let itList = []
    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem['it_id'] === arrItem){
          itList.push({
            it_id: dataItem['it_id'],
          })
        } 
      })
    })

    try {
      const res = await axios.post('/api/adm/itemConfigSelectDelete/', {it_list: itList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }

      setSuccSnack(true)
      setDelDial(false)
      setChecks([])
      setAllChecked(false)
      // setParam(!param)
      dispatch(setParamItm(!param))
      
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }, [checks, data])





  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.itemConfigBlock}>
      
      <div className={classes.box}>
        <div className={classes.h1SearchDiv}>
          <h1 className={classes.itemConfigBlockH1}>
            상품관리
            <div
                onClick={() => {
                  setChecks([])
                  setAllChecked(false)
                  setData([])
                  setAllQty(0)

                  // setPage(1)
                  // setSearchType1(0)
                  // setSearchType2(0)
                  // setKeyword('')
                  // setSearch(false)
                  // setPicSear(false)
                  // setSearchPic(1)
                  // setDelDial(false)
                  // setCheckedUse(false)
                  // setOrderUse(0)
                  dispatch(setItemPageInit())

                  getItems()
                }}
              style={{cursor:'pointer'}}
            >
              <MdOutlineRefresh/>
            </div>
          </h1>

          <div className={classes.bottomDiv}>  
            <div className={classes.formDiv}>
              <FormControl 
                size="small"
                className={ classes.formBox}
              >
                <Select
                  value={searchType1}
                  // onChange={(e) => setSearchType1(e.target.value)}
                  onChange={(e) => dispatch(setSearchType1Itm(e.target.value))}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value={0}>전체분류</MenuItem>
                  {cateList.length > 0 && cateList.map((item, idx) => (
                      <MenuItem key={idx} value={item['ca_id']}>{`${item['ca_name']}(${item['ca_id']})`}</MenuItem>
                  ))}
                    
                </Select>
              </FormControl>
            </div>
            <div className={classes.formDiv}>
              <FormControl 
                size="small"
                className={ classes.formBox}
              >
                <Select
                  value={searchType2}
                  // onChange={(e) => setSearchType2(e.target.value)}
                  onChange={(e) => dispatch(setSearchType2Itm(e.target.value))}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value={0}>상품명</MenuItem>
                  <MenuItem value={1}>상품코드</MenuItem>
                  <MenuItem value={2}>제조사</MenuItem>
                  <MenuItem value={3}>원산지</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className={ classes.RightDiv}>
              <TextField 
                label="검색어를 입력해주세요." 
                variant="standard" 
                value={keyword}
                // onChange={(e) => setKeyword(e.target.value)}
                onChange={(e) => dispatch(setKeywordItm(e.target.value))}
                onKeyDown={(e) => {
                  if(e.key === 'Enter') {
                    // setPage(1)
                    dispatch(setPageItm(1))
                    searchItem()
                  }
                }}
              />
              <Button 
                variant="outlined"
                onClick={() => {
                  // setPage(1)
                  dispatch(setPageItm(1))
                  searchItem()
                }}
              >
                검색
              </Button>
            </div>
            <div className={ classes.RightDiv}>
              <FormControl 
                sx={{ m: 1 }} 
                size="small"
                className={ classes.formBox}
              >
                <Select
                  labelId="select-small"
                  id="select-small"
                  inputProps={{ 'aria-label': 'Without label' }}
                  value={searchPic}
                  onChange={(e) => {
                    // setSearchPic(e.target.value)
                    dispatch(setSearchPicItm(e.target.value))
                  }}
                >
                  {picList.map((value, idx) => <MenuItem key={idx} value={value['pic_id']}>{value['pic_name']}</MenuItem>)}
                
                </Select>
                </FormControl>
                  <Button 
                    variant="outlined"
                    onClick={() => {
                      // setPicSear(true)
                      dispatch(setPicSearItm(true))
                      // setSearch(false)
                      dispatch(setSearchItm(false))
                      searchPicItem()
                    }}
                  >
                    담당자 검색
                  </Button>
              </div>
          </div> 

            <div className={classes.flexDiv}>
                <div className={ classes.RightDiv}>
                    <TextField 
                      variant="outlined" 
                      hiddenlabel="true" 
                      type='number'
                      size='small' 
                      value={allQty}
                      style={{ padding:'0 5px 0 0'}}
                      onChange={(e) => setAllQty(parseInt(e.target.value))}
                      onKeyDown={(e) => {
                        if(e.key === 'Enter') {
                          editAllQty()
                        }
                      }}
      
                    />
                    <Button 
                      variant="outlined"
                      onClick={() => {
                        editAllQty()
                      }}
                    >
                      재고 일괄 수정
                    </Button>
                </div>
                <div className={classes.btnDivTop}>
                  <div className={classes.btnDivTopLeft}>
                    <Button 
                    variant="outlined"
                    onClick={() => {
                      navigate("/DashboardMain/itemAdd");
                    }}
                  >
                    상품추가
                  </Button>
                  </div>
                  <div className={classes.btnDivTopRight}>
                    <div className={classes.btnButton}>
                      <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>
                        선택수정
                      </Button>
                    </div>
                    <div >
                      <Button variant="outlined" onClick={() => checks.length > 0 && setDelDial(true)}>
                        선택삭제
                      </Button>
                    </div>
                  </div>
                </div>
            </div> 
          </div>
        
        
        <div className={classes.datagridBox}>
          <div className={classes.head}>
              <div className={classes.checkBox}>
                <Checkbox 
                    checked={allChecked}
                    onChange={e => setAllChecked(e.target.checked)}
                />
              </div>
              <div 
                className={classes.imgBox}
              >
                이미지
              </div>
              <div className={classes.flexOutBox}>
                <div className={classes.flexBox}>
                  <div 
                    className={classes.inBox1}>
                    분류1
                  </div>
                  <div 
                    className={classes.inBox1}>
                    분류2
                  </div>
                  <div className={classes.inBox1}>
                    분류3
                  </div>
                  <div 
                    className={classes.inBox1}>
                    색상
                  </div>
                </div>
                <div className={classes.inBox3}>
                  상품명
                </div>
              </div>
              
              <div className={classes.twoBox}>
                <div className={classes.threeInBox1}>
                  가격
                </div>
                <div className={classes.threeInBox2}>
                  재고
                </div>
                <div className={classes.threeInBox3}>
                  <h1
                    // onClick={() => {
                    //   setOrderUse(orderUse + 1 >= 3 ? 0 : orderUse + 1)
                    // }}
                    onClick={() => {
                      dispatch(setOrderUseItm(orderUse + 1 >= 3 ? 0 : orderUse + 1))
                    }}
                    style={{cursor: 'pointer' ,color: `${orderUse === 1 ? '#37B400' : orderUse === 2 ? '	#a9a9a9' : 'black' }`}}
                  >
                    사용여부
                  </h1>
                  <Checkbox 
                    checked={checkedUse}
                    // onChange={e => setCheckedUse(e.target.checked)}
                    onChange={e => dispatch(setCheckedUseItm(e.target.checked))}
                  />
                </div>
              </div>
              <div className={classes.twoBox2}>
                <div className={classes.threeInBox1}>
                  담당자
                </div>
                <div className={classes.threeInBox2}>
                  구매처
                </div>
                <div className={classes.threeInBox3}>
                  판촉관련
                </div>
              </div>
              <div className={classes.oneBox}>
                관리
              </div>
              <div 
                className={classes.threeBox}>
                조회수
              </div>
            </div>
            <div className={classes.mobilehead}>  
                <div className={classes.checkBox}>
                  <Checkbox 
                      checked={checkedUse}
                      onChange={e => setAllChecked(e.target.checked)}
                  />
                </div>

                <div className={classes.twoBox3}>
                  <div 
                    className={classes.inBox2}
                  >
                      이미지
                  </div>
                  <div className={classes.inBox2}>
                    상품명
                  </div>
                </div>
                <div className={classes.twoBox}>
                  <div className={classes.threeInBox1}>
                    가격
                  </div>
                  <div className={classes.threeInBox2}>
                    재고
                  </div>
                  <div className={classes.threeInBox3}>
                    <h1
                      // onClick={() => {
                      //   setOrderUse(orderUse + 1 >= 3 ? 0 : orderUse + 1)
                      // }}
                      onClick={() => {
                        dispatch(setOrderUseItm(orderUse + 1 >= 3 ? 0 : orderUse + 1))
                      }}
                      style={{cursor: 'pointer' ,color: `${orderUse === 1 ? '#37B400' : orderUse === 2 ? '	#a9a9a9' : 'black' }`}}
                    >
                      사용여부
                    </h1>
                    <Checkbox 
                      checked={checkedUse}
                      // onChange={e => setCheckedUse(e.target.checked)}
                      onChange={e => dispatch(setCheckedUseItm(e.target.checked))}
                    />
                  </div>
                </div>
                <div className={classes.oneBox}>
                  관리
                </div> 
              </div>
            {loading ? (
              <div className={classes.load}>
                <TbLoader className={classes.loadingIcon}/>
              </div>
            ) :
            (data.length > 0 && type1.length > 0 && type2.length > 0 && type3.length > 0 && colorList.length > 0 && picList.length > 0) 
                      && <ItemConfigList 
                            checks={checks}
                            setChecks={setChecks}
                            type1={type1}
                            type2={type2}
                            type3={type3}
                            data={data}
                            setData={setData}
                            colorList={colorList}
                            picList={picList}
                            setAdmin={setAdmin}
                          />
            }
        </div>
  


        <div className={classes.navibox}>
          <AiOutlineDoubleLeft 
            // onClick={() => setPage(1)}
            onClick={() => dispatch(setPageItm(1))}
            className={classes.naviArrow}
            size="24"
          />
          <AiOutlineLeft 
            // onClick={() => setPage(page-5 <= 0 ? 1 : page-5)}
            onClick={() => dispatch(setPageItm(page-5 <= 0 ? 1 : page-5))}
            className={classes.naviArrow}
            size="24"
          />
          <Pagination
              activePage={page}
              itemsCountPerPage={15}
              totalItemsCount={pasings}
              pageRangeDisplayed={5}
              prevPageText={"‹"}
              nextPageText={"›"}
              onChange={handlePageChange}
              className={classes.navi}
              innerClass={classes.innerClass}    //안에?
              itemClass={classes.itemClass}      //아이템들?
              itemClassFirst={classes.itemClassFirst}    //first?
              itemClassLast={classes.itemClassLast}     // last
              linkClass={classes.linkClass}        // 아이템 링크
              activeClass={classes.activeClass}        // 현재페이지
              activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
              hideDisabled
              hideNavigation
              hideFirstLastPages
          />
          <AiOutlineRight 
            // onClick={() => setPage(page+5 > Math.ceil(pasings/15) ? Math.ceil(pasings/15) : page+5)}
            onClick={() => dispatch(setPageItm(page+5 > Math.ceil(pasings/15) ? Math.ceil(pasings/15) : page+5))}
            className={classes.naviArrow}
            size="24"
          />
          <AiOutlineDoubleRight 
            // onClick={() => setPage(Math.ceil(pasings/15))}
            onClick={() => dispatch(setPageItm(Math.ceil(pasings/15)))}
            className={classes.naviArrow}
            size="24"
          />
        </div>
  
        <div className={classes.btnDiv}>
          <div>
            <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>
              선택수정
            </Button>
          </div>
          <div className={classes.btnButton}>
            <Button variant="outlined" onClick={() => checks.length > 0 && setDelDial(true)}>
              선택삭제
            </Button>
          </div>
        </div>
  

  
  
        <Snackbar 
          open={errSnack} 
          autoHideDuration={6000} 
          onClose={snackClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
        >
          <Alert severity="error">수행을 실패 하였습니다!</Alert>
        </Snackbar>
        <Snackbar 
          open={succSnack} 
          autoHideDuration={6000} 
          onClose={snackClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
        >
          <Alert severity="success">수행을 성공 하였습니다!</Alert>
        </Snackbar> 

        <Dialog
          open={delDial}
          onClose={() => setDelDial(false)}
        >
          <DialogContent>
            <DialogContentText>
              정말 삭제 하시겠습니까?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDelDial(false)}>아니오</Button>
            <Button onClick={() => delSelItems()}>네</Button>
          </DialogActions>
        </Dialog>

      </div>
    </div>
  )
}

export default ItemConfig
